import { type GridColDef } from "@mui/x-data-grid";
import moment from "moment";

import { Organization } from "api/memberPortal/orgs/orgs.types";
import { Product } from "api/memberPortal/project/product/product.types";
import { PRODUCT_STATUSES } from "api/memberPortal/project/product/productStatuses.type";
import LinkCell from "components/MUI/DataGrid/Cells/Link.cell";
import { dataGridDateOnlyGetter } from "components/MUI/DataGrid/DataGrid.utils";

import PpClaimCell from "./cells/PpClaim.cell";
import ProductStatusCell from "./cells/ProductStatus.cell";
import ProductTableActionsCellProps from "./cells/ProductTableActions.cell";

interface BuildPineColumnsProps {
  setProduct: (_product: Product) => void;
  setShowDeleteModal: (_show: boolean) => void;
  setShowAmValTeamModal: (_show: boolean) => void;
  setShowValTeamModal: (_show: boolean) => void;
}

const buildPineColumns = ({
  setProduct,
  setShowDeleteModal,
  setShowAmValTeamModal,
  setShowValTeamModal,
}: BuildPineColumnsProps): GridColDef<Product>[] => [
  {
    headerName: "VID",
    field: "v_id",
    renderCell: ({ row }) => (
      <LinkCell to={`details/${row.product_id}`} label={row.v_id} />
    ),
    flex: 0,
    maxWidth: 70,
    align: "center",
  },
  {
    headerName: "Vendor",
    field: "vendor_id",
    valueGetter: (value: Organization) => value?.name ?? "",
    flex: 2,
  },
  { headerName: "Product", field: "product_name", flex: 3 },
  {
    headerName: "CCTL",
    field: "assigned_lab",
    valueGetter: (value: Organization) => value.name,
    flex: 2,
  },
  {
    headerName: "Kicked Off",
    field: "kicked_off_date",
    type: "date",
    valueGetter: dataGridDateOnlyGetter,
    valueFormatter: (value) =>
      value ? moment.utc(value).format("MM/DD/YYYY") : "Pending",
    flex: 2,
  },
  {
    headerName: "Product Status",
    field: "status",
    renderCell: ({ row }) => <ProductStatusCell product={row} />,
    flex: 2,
  },
  {
    headerName: "Archived Date",
    field: "sunset_date",
    type: "date",
    valueGetter: (value, row) =>
      value && row.status === PRODUCT_STATUSES.ARCHIVED ? value : null,
    valueFormatter: (value) =>
      value ? moment.utc(value).format("MM/DD/YYYY") : "Pending",
    flex: 2,
  },
  {
    headerName: "PP Claim",
    field: "pp_claim",
    renderCell: ({ row }) => <PpClaimCell product={row} />,
    flex: 3,
  },
  {
    headerName: "Days in Progress",
    field: "days_in_progress",
    valueFormatter: (value) => value ?? "Pending",
    flex: 2,
  },
  {
    headerName: "",
    field: "actions",
    sortable: false,
    align: "center",
    renderCell: ({ row }) => (
      <ProductTableActionsCellProps
        product={row}
        setProduct={setProduct}
        setShowDeleteModal={setShowDeleteModal}
        setShowAmValTeamModal={setShowAmValTeamModal}
        setShowValTeamModal={setShowValTeamModal}
      />
    ),
    flex: 0,
    maxWidth: 25,
  },
];

export default buildPineColumns;
